import React from "react";
const RicosNodeContext = React.createContext(null);
const RicosNodeContextProvider = ({
  parentNode,
  parentIndex,
  children
}) => {
  return /* @__PURE__ */ React.createElement(RicosNodeContext.Provider, { value: { parentNode, parentIndex } }, children);
};
function withRicosNodeContext(Component) {
  return function(props) {
    return /* @__PURE__ */ React.createElement(RicosNodeContext.Consumer, { key: Math.random().toString().slice(2, 9) }, ({ parentNode, parentIndex }) => /* @__PURE__ */ React.createElement(Component, { ...props, parentNode, parentIndex }));
  };
}
export {
  RicosNodeContext,
  RicosNodeContextProvider,
  withRicosNodeContext
};
//# sourceMappingURL=ricos-node-view-context.js.map
